export default {
  judgment: '判案書',
  corrigendum: '勘誤', 
  case: '判案書',
  casename: '案件名稱',
  others: '法律相關文件',
  aboutdb: '關於',
  dbs: '資料庫',
  indivDbs: '個別資料庫',
  toc: '目錄',
  toc_short: '目錄',
  cright: '版權',
  lang: "語言",
  sortby: "排序方式",
  relevance: "相關性",
  citfreq: '引文次數',
  date: '日期',
  title: '標題',
  captitle: "法例標題",
  startdate: '開始日期',
  enddate: '結束日期',
  daterange: "日期範圍",
  capno: "法例章號",
  cap: "章號",
  action: '案件號碼',
  pd: '實務指示',
  pd_num: '號碼',
  case_a: '案件',
  appeal: '上訴',
  appealhis: '查閱{0}紀錄',
  appealhistitle: '案件 {1} 的{0}紀錄',
  wdg_relatedcap: '相關',
  wdg_relatedcap_nil: '此條例沒有相關的附屬法例。',
  wdg_status: '更新狀態',
  wdg_status_filecount: '文件數量',
  wdg_status_judcount: '判案書數量',
  wdg_status_dbcount: '現有資料庫',
  wdg_status_fileunit: '份',
  wdg_status_updatetime: '更新時間',
  wdg_status_foundCount: '相關文件',
  wdg_download: '下載',
  wdg_viewops: '閱讀選項',
  wdg_viewops_trans: '此文件沒有譯本。',
  wdg_jdg: '有關此判案書',
  wdg_jdg_neutral: '通用編號',
  wdg_jdg_pcit: '判例引文',
  wdg_legis_vercount: '版本數量',
  wdg_legis_latest: '目前版本',
  wdg_legis_enact: '生效日期',
  wdg_treaty: '有關此公約',
  wdg_treaty_cat: '分類',
  wdg_treaty_body: '組織',
  wdg_legis: '有關此法例',
  wdg_legis_info: '資料',
  wdg_goto: '查閱官方資料庫',
  wdg_goto_elegis: '電子版香港法例 （e-Legislation）',
  wdg_goto_elegis_tooltip: '於香港官方法例資料庫查看此法例',
  wdg_doc: '有關此文件',
  wdg_lang: '語言版本選擇',
  wdg_ref_s: '引述此章號的文件',
  wdg_ref_l: '引述此法例的文件',
  wdg_ref_d: '引述此公文的文件',
  wdg_ref_c: '引述此判案書的文件',
  wdg_ref_lawcite: '搜尋引用此文件的其他文件及此文件引用過的文件',
  wdg_ref_lawcite_legis: '搜尋引用此文件的其他文件及此文件引用過的文件',
  wdg_ref_noteup: '搜尋引用此文件的其他文件',
  wdg_ref_noteup_legis: '搜尋引用此文件的其他文件',
  wdg_contents: '本頁目錄',
  wdg_translation: '翻譯本',
  wdg_judgment_tag: '相關概念',
  warning: '注意',
  pastver: '這是過去版本，最新情況請見現行版本。',
  compareversion: '請選版本以作比較',
  compare_explanation: '各版本的不同之處已用顏色標記。',
  compare_diff: '已選版本沒有任何改動。',
  compare: '比較',
  version: '版本',
  compare_title: '法例版本比較',
  filter: '篩選',
  filter_to: '至',
  filter_and: '與',
  totip_preSec: '上一章',
  totip_nextSec: '下一章',
  loading: '載入中…',
  rsidetitle: '有關此頁的資訊',
  fullsection: '本法例內容一覽',
  legisdb_filter_hint: '點擊分類以套用或取消',
  togglehl_hint: '點擊開啟/關閉搜尋字螢光效果',
}